import { exportFormats } from "./exportFormats";
import { ContactAddressType } from "../common/ContactAddress.type";
import { pickRepresentativePhone, pickPhoneByLabel, LABEL_CODE_OFFICE } from "./pickRepresentativePhone";

export const preprocessExportData = (data: ContactAddressType[], format: string): any[] => {
    const config = exportFormats[format];
    if (!config) return data;

    let rows = data;

    if (format === "standard") {
        // phone 列に代表電話番号を出力（種別追加により旧列が空になった連絡先の番号欠落を防ぐ）
        rows = data.map(row => ({
            ...row,
            phone: pickRepresentativePhone(row),
            profileImage: "",
        }));
    }

    if (format === "yealink") {
        rows = data.map(row => {
            const full = `${row.lastName ?? ""}${row.firstName ?? ""}`.trim();

            // mobile_number ← 代表電話番号（必ず1件は出力される）
            const representative = pickRepresentativePhone(row);

            // office_number ← 勤務先(2)。無ければ従来の mobilePhone を使用。
            // 代表番号と同一なら重複を避けて空にする。
            let office = pickPhoneByLabel(row, LABEL_CODE_OFFICE) || (row.mobilePhone ?? "").trim();
            if (office === representative) office = "";

            return {
                ...row,
                phone: representative,   // mapping: mobile_number ← phone
                mobilePhone: office,     // mapping: office_number ← mobilePhone
                // telExtension はそのまま other_number（内線）へ出力する
                fullName: full !== "" ? full : (row.contactName ?? "")
            };
        });
    }

    if (format === "cloudbiz") {
        rows = data.map(row => {
            const full = `${row.lastName ?? ""}${row.firstName ?? ""}`.trim();

            return {
                ...row,
                // 電話番号 ← 代表電話番号
                phone: pickRepresentativePhone(row)
                    .replace(/\r?\n/g, "")
                    .replace(/^'/, "")
                    .replace(/["]/g, "")
                    .trim(),

                memo: (row.memo ?? "")
                    .replace(/\r?\n/g, "")
                    .trim(),

                fullName: full !== "" ? full : (row.contactName ?? ""),
                kanaFull: `${row.lastNameKana ?? ""}${row.firstNameKana ?? ""}`,

                lineType: "外線",
                telExtension: "",
                shortNumber: "",
                oneTouchNumber: "",
            };
        });
    }


    const mapped = rows.map((row) => {
        const obj: Record<string, any> = {};

        config.headers.forEach((header) => {
            const key = config.mapping[header];
            obj[header] = key ? (row as any)[key] ?? "" : "";
        });

        return obj;
    });

    return mapped;
};
